import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Radio from 'components/shared/StandaloneRadio';

/**
 * !! HAS A MODERN TWIN: projectProperties/modern/PropertyRadio.jsx !!
 *
 * That file is a verbatim copy of everything in this class except render(). Any change
 * to the state machine, the handlers or componentDidUpdate MUST be mirrored there, or
 * the two will drift and screens will behave differently depending on which variant
 * they import. Only the layout is allowed to differ.
 *
 * This duplication is temporary: see the note in modern/PropertyRadio.jsx for how to
 * collapse the two once the modern layout has settled.
 */
export default class PropertyRadio extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.valueForTrue.indexOf(this.props.property.value) !== -1
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        //const value = e.target.checked;
        this.props.handleChange(this.props.property.info.name, this.props.valueForTrue[0]);

        const value = this.props.valueForTrue.indexOf(this.props.property.value);

        this.setState({
            isChecked: value === -1 ? false : true
        });
    }

    render() {

        return (
            <Row style={{ margin: "0.75rem auto 0" }}>
                <Col sm="9" style={{ margin: "auto 0", padding: "0" }}>
                    {/* {this.props.property.info.displayName.replace(/([A-Z])/g, ' $1')} */}
                    {this.props.title}
                </Col>

                <Col sm="3">
                    <Form>
                        <Radio
                            disabled={this.props.disabled}
                            style={{ padding: "0" }}
                            name={this.props.property.info.name}
                            checked={this.props.isChecked}
                            onClick={this.handleChange}
                            onChange={this.handleChange}
                        />
                        {/* <input
                            name={this.props.property.info.name}
                            type="radio"
                            checked={this.props.isChecked}
                            onClick={this.handleChange}
                            onChange={this.handleChange} /> */}
                    </Form>
                </Col>
            </Row>
        );
    };
}
